import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404 — Not Found page.
 * Themed to match the golf course night aesthetic.
 */
export default function NotFound() {
  return (
    <section className="flex items-center justify-center min-h-[70vh] px-6 py-20">
      <div className="text-center max-w-md mx-auto">
        {/* Lost golf ball illustration */}
        <div className="relative inline-flex items-center justify-center mb-8">
          {/* Outer glow */}
          <div
            className="absolute -inset-10 rounded-full"
            style={{
              background: 'radial-gradient(circle, rgba(239,68,68,0.08), transparent 70%)',
              filter: 'blur(20px)',
            }}
          />
          {/* Ball in rough */}
          <div
            className="relative w-28 h-28 rounded-full flex items-center justify-center"
            style={{
              background: 'linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.015))',
              border: '1.5px solid rgba(255,255,255,0.08)',
              boxShadow: '0 0 60px rgba(239,68,68,0.06), inset 0 1px 2px rgba(255,255,255,0.04)',
            }}
          >
            <span className="text-6xl select-none" style={{ filter: 'drop-shadow(0 4px 12px rgba(239,68,68,0.2))' }}>
              🏌️
            </span>
          </div>
        </div>

        {/* 404 text */}
        <h1
          className="text-7xl md:text-9xl font-black text-white/10 tracking-tighter mb-2"
          style={{ textShadow: '0 2px 40px rgba(239,68,68,0.08)' }}
        >
          404
        </h1>

        <h2 className="text-lg md:text-xl font-bold text-white/80 mb-3">
          Ball's in the rough
        </h2>

        <p className="text-sm text-white/40 font-light leading-relaxed mb-8 max-w-xs mx-auto">
          Looks like that shot went out of bounds. This hole doesn't exist on our course.
        </p>

        {/* Navigation options */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: 'linear-gradient(135deg, rgba(34,197,94,0.15), rgba(34,197,94,0.06))',
              border: '1px solid rgba(34,197,94,0.25)',
              color: 'rgba(34,197,94,0.9)',
              boxShadow: '0 4px 16px rgba(34,197,94,0.1)',
            }}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Back to Clubhouse
          </Link>

          <Link
            to="/events"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-mono text-white/40 hover:text-white/70 transition-colors duration-300"
            style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
            }}
          >
            View Events
          </Link>
        </div>

        {/* Fun easter egg text */}
        <p className="mt-10 text-[10px] font-mono text-white/15 tracking-wider uppercase">
          Penalty stroke assessed · Take a drop
        </p>
      </div>
    </section>
  );
}
